import React from "react";
import AdvanceTable from "../base/AdvanceTable";
import AdvanceTableFooter from "../base/AdvanceTableFooter";
import { Badge } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faClock,
    faMoneyBillWave
} from "@fortawesome/free-solid-svg-icons";
import { createColumnHelper } from "@tanstack/react-table";
import { Link } from "react-router-dom";
import { PrazoDto } from "services/prazoService";

const columnHelper = createColumnHelper<PrazoDto>();

export const prazoTableColumns = [
    columnHelper.accessor("parcela", {
        header: "Parcelas",
        cell: ({ getValue }) => (
            <div className="d-flex align-items-center">
                <FontAwesomeIcon icon={faClock} className="me-2 text-body-secondary" />
                <span className="fw-semibold">{getValue()}x</span>
            </div>
        ),
        size: 120,
    }),
    columnHelper.accessor("descricao", {
        header: "Descrição",
        cell: ({ row: { original } }) => {
            const { descricao, id } = original;
            return (
                <Link
                    to={`/cadastros/prazos/${id}`}
                    className="fw-semibold line-clamp-3"
                >
                    {descricao}
                </Link>
            );
        },
        meta: {
            headerProps: { style: { width: 350 }, className: "ps-4" },
            cellProps: { className: "ps-4" },
        },
    }),
    columnHelper.accessor("formasPagamentoCount", {
        header: "Formas de Pagamento",
        cell: ({ getValue }) => (
            <div className="d-flex align-items-center">
                <FontAwesomeIcon icon={faMoneyBillWave} className="me-2 text-body-secondary" />
                <Badge bg="light" text="dark" className="border">
                    {getValue()} forma(s)
                </Badge>
            </div>
        ),
        size: 180,
    }),
    columnHelper.accessor("isDeleted", {
        header: "Status",
        cell: ({ getValue }) => (
            <Badge bg={getValue() ? "danger" : "success"}>
                {getValue() ? "Inativo" : "Ativo"}
            </Badge>
        ),
        size: 100,
    }),
    columnHelper.accessor("createdAt", {
        header: "Criado em",
        cell: ({ getValue }) => {
            const date = new Date(getValue());
            return (
                <span className="text-body-secondary">
                    {date.toLocaleDateString("pt-BR")}
                </span>
            );
        },
        size: 120,
    }),

];

const PrazoTable: React.FC = () => {
    return (
        <>
            <AdvanceTable tableProps={{ className: "fs-9 mb-0" }} />
            <AdvanceTableFooter pagination />
        </>
    );
};

export default PrazoTable;